import React from 'react';
import {
    Container,
    Typography,
    makeStyles
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import NewUserForm from './NewUserForm';
const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export default function UserNewView() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Page
            className={classes.root}
            title={t('title.create_user')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('title.create_user')}
                </Typography>
                <NewUserForm/>
            </Container>
        </Page>
    );
}